import { writable } from 'svelte/store';

export const recentlyAddedItems = writable({ items: [], cursor: 0 });
export const albumsItems = writable({ items: [], cursor: 0 });
export const playlistsItems = writable({ items: [], cursor: 0 });
export const currentLocation = writable("");
